goog.provide("shadow.js.shim.module$ol$Feature$default");
shadow.js.shim.module$ol$Feature$default = shadow.js.require(122, {}).default;
